import React from 'react';
import { motion } from 'framer-motion';

// BUG: Zoomed in image is 100% width of screen
// TODO: Zoomed in image to resize to actual size

const frameVariant = {
  init: {
     display: 'none' ,
    opacity: 0
  },
  zoom: {
     display: 'block',
    opacity: 1
  }
}

const Frame =({pose, ...otherProps}) => {
  return (
    <motion.div {...otherProps} animate={pose} variants={frameVariant}></motion.div>
  )
}

const transition = {
  duration: 0.3,
  ease: [0.08, 0.69, 0.2, 0.99]
};

const imageVariant = {
  init: {
    position: 'static',
    width: 'auto',
    height: 'auto',
    transition,
    flip: true
  },
  zoom: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    transition,
    flip: true,
  }
}

const Image=({pose, ...otherProps})=> {
  return (
    <motion.img init={'init'} animate={pose} variants={imageVariant} {...otherProps}></motion.img>
  )
}

class Zoom extends React.Component {
  state = { isZoomed: false };

  zoomIn() {
    window.addEventListener('scroll', this.zoomOut);
    this.setState({ isZoomed: true });
  }

  zoomOut = () => {
    window.removeEventListener('scroll', this.zoomOut);
    this.setState({ isZoomed: false });
  };

  toggleZoom = () => (this.state.isZoomed ? this.zoomOut() : this.zoomIn());

  render() {
    const { isZoomed } = this.state;
    const { imageWidth, imageHeight, ...otherProps } = this.props;
    const pose = isZoomed ? 'zoom' : 'init';

    return (
      <div
        style={{ width: imageWidth, height: imageHeight }}
        onClick={this.toggleZoom}
      >
        <Image
          pose={pose}
          className={pose === 'zoom' ? 'zoomed' : 'zoomable'}
          {...otherProps}
        />
        <Frame pose={pose} className="frame" />
      </div>
    );
  }
}

export default Zoom;
